import 'angular';
import * as _ from 'lodash-es';
import AppConstants from '../gorillaboy/AppConstants';
import './templates/permission_panel.html';
import {RootScope} from '../types/angular-types';

angular.module('GorillaBoy.directives')
.directive('permissionPanel',
    ['$rootScope',
    '$q',
    '$log',
    '$timeout',
    '$translate',
    '$location',
    '$window',
    'authenticatedUser',
    'CheckinCheckoutController',
    'ResourceService',
    'GroupService',
    'MessageProvider',
    'MessageManager',
    'SignalProvider',
    'ShareLinkService',
    ($rootScope, $q, $log, $timeout, $translate, $location, $window, authenticatedUser, CheckinCheckoutController, ResourceService, GroupService, MessageProvider, MessageManager, SignalProvider, ShareLinkService) => {
    return {
        scope: {
            showRightSidebar: '=',
            files: '<',
            folders: '<',
            userActionsMap: '<',
            isDocumentCheckedOut: '&',
            getCheckedOutTooltip: '&',
            pickShareLinkFolderModal: '&',
            pickShareLinkDocumentModal: '&'
        },
        templateUrl: './directives/templates/permission_panel.html',
        link: ($scope, $element, $attrs) => {
            /* CONSTANTS */
            var collaboratorTypes = AppConstants.CollaboratorTypes,
                globalRoles = AppConstants.GlobalRoles,
                NUM_GROUP_USERS_SHOWN = 8,
                RESOURCE_TYPES = AppConstants.ResourceTypes,
                sharedLinkScope = AppConstants.SharedLinkScope;
            $scope.PERMISSION_PANEL_MODES = {
                NONE_SELECTED: 'NONE_SELECTED',
                SINGLE_SELECTED: 'SINGLE_SELECTED',
                MULTIPLE_SELECTED: 'MULTIPLE_SELECTED'
            };
            $scope.RoleTypes = AppConstants.RoleTypes;

            /* VARIABLES */
            var groupUserMarker = null,
            usersInGroup = [];

            $scope.principals = null;
            $scope.principalsLoaded = false;
            $scope.resource = null;
            $scope.resourceType = null;
            // This is the data structure used to feed into personEntry or groupEntry
            $scope.resourceInfo = null;
            $scope.permissionPanelMode = null;

            $scope.groupInfo = {
                expandGroupShown: false,
                selectedGroup: null,
                groupMembers: [],
                role: null,
                hideShowMore: false,
                errorText: ''
            };

            $scope.showLockInfo = function() {
                return ($scope.resourceType === RESOURCE_TYPES.FILE) && $scope.isDocumentCheckedOut({doc: $scope.resource});
            };

            $scope.isFolderShared = function() {
                return $scope.resourceType === RESOURCE_TYPES.FOLDER && $scope.isSharedWithOthers;
            };

            $scope.getResourceName = function() {
                if (!$scope.resource || !$scope.resourceType) {
                    return null;
                }
                if ($scope.resourceType === RESOURCE_TYPES.FILE) {
                    return $scope.resource.VersionMetadata.Name;
                } else if ($scope.resourceType === RESOURCE_TYPES.FOLDER) {
                    return $scope.resource.Name;
                } else {
                    return null;
                }
            };

            $scope.switchTab = function(entityEntry) {
                if (entityEntry.Type === collaboratorTypes.GROUP) {
                    switchToGroup(entityEntry);
                }
            };

            $scope.getPermissionLevel = function(principal) {
                var permissionOrder = [globalRoles.VIEWER, globalRoles.CONTRIBUTOR, globalRoles.COOWNER, globalRoles.OWNER];
                if (!principal || !principal.Role) {
                    //Any undefined/null objects get zero permission level
                    $log.error("Cannot get permission level from the principal. Received : " + principal);
                    return 0;
                }
                // Reviewer role is not available in Rainier, defaulting to Viewer role. 
                if (principal.Role === 'REVIEWER') {
                    return 0;
                }
                return permissionOrder.indexOf(principal.Role);
            };

            // when user click 'load more' button
            $scope.showMoreUsers = function() {
                appendMoreUsers();

                // If there are no more users and the marker is not null, make an API call to repopulate the array.
                if (usersInGroup.length === 0 && groupUserMarker) {
                    getUsersInGroup($scope.groupInfo.selectedGroup).then(function() {}, function(error) {
                        $scope.groupInfo.errorText = MessageProvider.requestEntityTooLargeMessage;
                        $scope.groupInfo.hideShowMore = true;
                    });
                }
            };

            // Return a boolean that indicates whether the current user has share permission for the given resource
            $scope.hasSharePermission = function() {
                return $scope.userActionsMap[$scope.resource.Id].canShare;
            }

            $scope.isGroupSelected = function(group) {
                return $scope.groupInfo.selectedGroup && $scope.groupInfo.selectedGroup === group;
            };

            $scope.clearExpandingGroup = function () {
                $rootScope.$broadcast(SignalProvider.Group.ClearExpandingGroup);
            };

            $scope.manageLinkAccess = function() {
                if ($scope.resourceType === RESOURCE_TYPES.FOLDER) {
                    $scope.pickShareLinkFolderModal({folder: $scope.resource});
                } else {
                    $scope.pickShareLinkDocumentModal({doc: $scope.resource});
                }
            };

            $scope.copyShareLink = function() {
                ShareLinkService.copyLinkToClipboard($scope.shareLink);
            };

            $scope.$on(SignalProvider.Selection.SelectionUpdated, function() {
                // Put the update function in timeout to make sure the local $scope.folders and $scope.files
                // have been synchronized.
                $timeout(updatePermissionPanel);
            });

            // Reset group variables after switch back to people tab
            $scope.$on(SignalProvider.Group.ClearExpandingGroup, function() {
                $scope.groupInfo.groupMembers = [];
                $scope.groupInfo.hideShowMore = false;
                $scope.groupInfo.expandGroupShown = false;
                $scope.groupInfo.selectedGroup = null;
                $scope.groupInfo.errorText = '';
                usersInGroup = [];
                groupUserMarker = null;
            });

            $scope.$on(SignalProvider.Permission.PermissionUpdated, updatePrinciples);

            //////////////////////
            // Initialize
            //////////////////////
            updatePermissionPanel();

            // This function updates principals by calling resource permission API
            function updatePrinciples() {
                var deferred = $q.defer();
                $scope.principalsLoaded = false;
                ResourceService.describeResourcePermissions($scope.resource.Id, ['PRINCIPALS']).then(function(results) {
                    var shareLinkScope = ShareLinkService.getSharedLinkScope(results.data.Principals);
                    $scope.hasShareLink = !!shareLinkScope;
                    $scope.manageLinkDetail = ShareLinkService.getLinkPermissionsDetail(shareLinkScope);
                    $scope.shareLink = ShareLinkService.getShareLink(shareLinkScope, $scope.resource.Id, $scope.resourceType);
                    $scope.isSharedWithOthers = isSharedWithOthers(results.data);
                    var permissions = ResourceService.processResourcePermissionResponse(results.data, authenticatedUser.getUserInfo());
                    $scope.principals = permissions.principals;
                    $scope.principalsLoaded = true;
                }, function() {
                    deferred.reject('cannot get resource permission');
                });
                return deferred.promise;
            };

            // This function updates resource metadata based on given folders and files
            function updateResourceAndPanelMode() {
                var folders = _.values($scope.folders);
                var files = _.values($scope.files);
                if (folders.length + files.length === 0) {
                    $scope.resource = null;
                    $scope.resourceType = null;
                    $scope.resourceInfo = null;
                    $scope.permissionPanelMode = null;
                    $scope.permissionPanelMode = $scope.PERMISSION_PANEL_MODES.NONE_SELECTED;
                } else if (folders.length + files.length === 1) {
                    if (folders.length === 1) {
                        $scope.resource = folders[0];
                        $scope.resourceType = RESOURCE_TYPES.FOLDER;
                        $scope.resourceInfo = {
                            resourceType: RESOURCE_TYPES.FOLDER,
                            Id: $scope.resource.Id
                        };
                    } else {
                        $scope.resource = files[0];
                        $scope.resourceType = RESOURCE_TYPES.FILE;
                        $scope.resourceInfo = {
                            resourceType: RESOURCE_TYPES.FILE,
                            Id: $scope.resource.Id
                        };
                    }
                    $scope.permissionPanelMode = $scope.PERMISSION_PANEL_MODES.SINGLE_SELECTED;
                } else {
                    $scope.resource = null;
                    $scope.resourceType = null;
                    $scope.resourceInfo = null;
                    $scope.permissionPanelMode = $scope.PERMISSION_PANEL_MODES.MULTIPLE_SELECTED;
                }

                // When the permission panel model is updated, clear group view if the panel is
                // currently in group view
                if ($scope.groupInfo.expandGroupShown) {
                    $scope.clearExpandingGroup();
                }
            }

            // This function updates the model of the directive
            function updatePermissionPanel() {
                updateResourceAndPanelMode();
                if ($scope.resource) {
                    updatePrinciples();
                }
            }

            // Grabs NUM_GROUP_USERS_SHOWN users from the usersInGroup array and appends it to the groupMembers array.
            function appendMoreUsers() {
                var moreUsers = usersInGroup.splice(0, NUM_GROUP_USERS_SHOWN);

                // If there are less than NUM_GROUP_USERS_SHOWN users left, or
                // if we already fetch the last page of group members and there are no users leftover
                // then hide the "load More" button.
                if (moreUsers.length < NUM_GROUP_USERS_SHOWN || (usersInGroup.length === 0 && !groupUserMarker)) {
                    $scope.groupInfo.hideShowMore = true;
                }

                // Concat moreUsers to the array of users shown in the people tab
                $scope.groupInfo.groupMembers = $scope.groupInfo.groupMembers.concat(moreUsers);
            }

            // This function gets called when a user expands users in a group
            function switchToGroup(groupEntry) {
                $scope.groupInfo.selectedGroup = groupEntry;
                $scope.groupInfo.groupName = groupEntry.Name;

                switch (groupEntry.Role) {
                    case globalRoles.VIEWER:
                        $scope.groupInfo.role = $translate.instant('RIGHT_NAV.VIEWER');
                        break;
                    case globalRoles.CONTRIBUTOR:
                        $scope.groupInfo.role = $translate.instant('RIGHT_NAV.CONTRIBUTOR');
                        break;
                    case globalRoles.COOWNER:
                        $scope.groupInfo.role = $translate.instant('RIGHT_NAV.CO_OWNER');
                        break;
                }

                // Populate the usersInGroup array, then append NUM_GROUP_USERS_SHOWN (8 by default) users to the view.
                getUsersInGroup(groupEntry).then(function() {
                    appendMoreUsers();
                }, function(error) {
                    $scope.groupInfo.errorText = MessageProvider.requestEntityTooLargeMessage;
                    $scope.groupInfo.hideShowMore = true;
                });

                $timeout(function() {
                    $scope.groupInfo.expandGroupShown = true;
                }, 500);
            }

            // Makes the API call to populate the usersInGroup array.
            // This returns a promise so #switchToGroup can make the call to #appendMoreUsers on success.
            function getUsersInGroup(groupEntry) {
                var deferred = $q.defer();

                GroupService.getUsersInGroup(groupEntry.Id, groupEntry.Vendor, ['PRINCIPALS'], groupUserMarker)
                .then(function(res) {
                    if (res && res.Users) {
                        // Populate usersInGroup with the results.
                        angular.forEach(res.Users, function(value) {
                            usersInGroup.push(value);
                        });
                        groupUserMarker = res.Marker;
                        deferred.resolve();
                    } else {
                        // If service returns no results, then hide the "Show More" button.
                        $scope.groupInfo.hideShowMore = true;
                        deferred.resolve();
                    }

                }).catch(function(error) {
                    deferred.reject(error);
                });

                return deferred.promise;
            }

            function isSharedWithOthers(data) {

                for (var i = 0; i < data.Principals.length; i++) {
                   var principal = data.Principals[i];
                   if (principal.Roles && principal.Roles[0] && principal.Roles[0].Role
                      && principal.Roles[0].Role != globalRoles.OWNER
                      && principal.Type && principal.Type == collaboratorTypes.USER){

                      return true;
                   }
                }

                return false;
            }
        }
    };
}])
